import { css } from '@emotion/react'
import { Cell, Grid } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { Equipe, Familia } from 'graphql/types.generated'
import { Fragment } from 'react'
import { AlertCriteriosSugestivos } from 'view/atendimentos/detail/prontuario-familiar/acompanhamento-vulnerabilidade/AlertCriteriosSugestivos'
import { FamiliaAcompanhamentoVulnerabilidadeSection } from 'view/atendimentos/detail/prontuario-familiar/acompanhamento-vulnerabilidade/FamiliaAcompanhamentoVulnerabilidadeSection'
import { CidadaoFamiliaCard } from 'view/cadastro-imovel/components/CidadaoFamiliaCard'
import { getResponsavelDependentesFamilia } from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { CidadaoTerritorioBasicoWithProntuarioId } from '../model-visualizacao-imovel'
import { convertCidadaoTerritorioToCidadaoCard } from '../visualizacao-imovel-converter'
import { FamiliaSectionHeader } from './FamiliaSectionHeader'
import { VisualizarCidadaoButton } from './VisualizarCidadaoButton'

interface FamiliaSectionProps {
  familia: Omit<Familia, 'cidadaos' | 'equipe' | 'imovel' | 'cidadaosTerritorioBasico'> & {
    equipe?: Pick<Equipe, 'nome'>
    cidadaosTerritorioBasico: ReadonlyArray<CidadaoTerritorioBasicoWithProntuarioId>
  }
  isProntuarioFamiliar?: boolean
  isCardVulnerabilidade?: boolean
}

export const FamiliaSection = (props: FamiliaSectionProps) => {
  const { familia, isProntuarioFamiliar = false, isCardVulnerabilidade = true } = props

  const { PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED } = useFlags()

  const { responsavel, dependentes } = getResponsavelDependentesFamilia(familia)
  const cidadaoIds = familia.cidadaosTerritorioBasico.map((cidadao) => cidadao.id)

  return (
    <Grid
      style={
        !isProntuarioFamiliar &&
        css`
          padding: 0.5rem;
          margin-top: 0.75rem;
        `
      }
    >
      <FamiliaSectionHeader
        nomeResponsavel={responsavel?.nomeSocial?.titleCase() ?? responsavel?.nome?.titleCase()}
        numeroProntuarioFamiliar={familia.numeroProntuarioFamiliar}
        rendaFamiliar={familia.rendaFamiliar}
        resideDesde={familia.resideDesde}
        numeroMembros={familia.numeroMembros}
        nomeEquipe={familia?.equipe?.nome}
        isProntuarioFamiliar={isProntuarioFamiliar}
      />
      <Cell size={12}>
        <FamiliaAcompanhamentoVulnerabilidadeSection cidadaoIds={cidadaoIds} familiaId={familia.id} />
      </Cell>
      {PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED && isCardVulnerabilidade && (
        <Cell size={12}>
          <AlertCriteriosSugestivos />
        </Cell>
      )}
      {responsavel && (
        <Cell size={12}>
          <CidadaoFamiliaCard
            cidadao={convertCidadaoTerritorioToCidadaoCard(responsavel)}
            isResponsavel
            possuiFichaNaoProcessada={responsavel.ultimaFichaCadastrada?.isProcessado !== true}
            buttonComponent={
              <VisualizarCidadaoButton cidadaoId={responsavel.id} prontuarioId={responsavel?.prontuario?.id} />
            }
          />
        </Cell>
      )}
      {dependentes
        .filter((cidadao) => !cidadao.isFaleceu)
        .map((cidadao) => {
          return (
            <Fragment key={cidadao.id}>
              {cidadao.id !== responsavel?.id && (
                <Cell size={12}>
                  <CidadaoFamiliaCard
                    cidadao={convertCidadaoTerritorioToCidadaoCard(cidadao)}
                    isResponsavel={false}
                    possuiFichaNaoProcessada={cidadao.ultimaFichaCadastrada?.isProcessado !== true}
                    buttonComponent={
                      <VisualizarCidadaoButton cidadaoId={cidadao.id} prontuarioId={cidadao?.prontuario?.id} />
                    }
                  />
                </Cell>
              )}
            </Fragment>
          )
        })}
    </Grid>
  )
}
